






export default {
    name: "Accordion",
    data() {
        return {
            panels: [],
            selectedPanel: null,
        };
    },
    provide() {
        return {
            onSelect: this.selectPanel,
        };
    },
    methods: {
        selectPanel: function (selectedPanel) {
            this.panels = this.$children;
            _.forEach(this.panels, function (panel) {
                panel.collapsed = true;
                panel.panelClass = "panel-default";
            });
            selectedPanel.collapsed = false;
            selectedPanel.panelClass = "panel-primary";
        },
    },
};
